import React from "react";
import { Link } from "react-router-dom";
import "../style/footer.css";
const Footer = () => {
  return (
    <>
      <div className="footer">
        <div className="bottom_brdr">
          <div className="dark_clr"></div>
          <div className="light_clr"></div>
        </div>
        <div className="footer_inr">
          <div className="ftr_col_1">
            <div className="ftr_ttl"> Our Products </div>
            <ul>
              <li>
                <Link id="chan" href="https://www.easemytrip.com/flights.html">
                  Book Flights
                </Link>
              </li>
              <li>
                <Link id="chan" href="https://www.easemytrip.com/refer">
                  Refer & Earn
                </Link>
                <div className="skew2_v1">
                  <p className="n_deal2">New</p>
                </div>
              </li>
              <li>
                <Link id="chan" href="https://www.easemytrip.com/flight-status">
                  Flight Status
                </Link>
              </li>
              <li>
                <Link id="chan" href="https://www.easemytrip.com/hotels/">
                  Hotel Booking
                </Link>
              </li>
              <li>
                <Link id="chan" href="https://www.easemytrip.com/railways/">
                  Trains
                </Link>
              </li>
              <li>
                <Link id="chan" href="//www.easemytrip.com/airfare-calender">
                  Lowest Airfare Calendar
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="//www.easemytrip.com/domestic-flights.html"
                >
                  Domestic Flights
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="//www.easemytrip.com/international-flights.html"
                >
                  International Flights
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/holiday-packages.html"
                >
                  Holiday Packages
                </Link>
              </li>
              <li>
                <Link id="chan" href="https://www.easemytrip.com/bus/">
                  Bus
                </Link>
              </li>
              <li>
                <Link id="chan" href="https://www.easemytrip.com/cabs">
                  Cabs
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="//www.easemytrip.com/franchise/index.html"
                >
                  Franchise
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/mice/index.html"
                  target="_new"
                >
                  <span>Mice</span>
                </Link>
              </li>
            </ul>
          </div>
          <div className="ftr_col_1">
            <div className="ftr_ttl"> EMT Info </div>
            <ul>
              <li>
                <Link id="chan" href="//www.easemytrip.com/privacy-policy.html">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link id="chan" href="//www.easemytrip.com/terms.html">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link id="chan" href="//www.easemytrip.com/user-agreement.html">
                  User Agreement
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="//www.easemytrip.com/investor-relations.html"
                >
                  Investors Relation
                </Link>
              </li>
              <li>
                <Link id="chan" href="//www.easemytrip.com/mobile-app.html">
                  Mobile App
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="//www.easemytrip.com/achievements/index.html"
                >
                  Achievements
                </Link>
              </li>
              <li>
                <Link id="chan" href="//www.easemytrip.com/career.html">
                  Career
                </Link>
              </li>
              <li>
                <Link id="chan" href="//www.easemytrip.com/about-us.html">
                  About Us
                </Link>
              </li>
              <li>
                <Link id="chan" href="//www.easemytrip.com/contact-us.html">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="ftr_col_1">
            <div className="ftr_ttl"> SITE DIRECTORY </div>
            <ul>
              <li>
                <Link
                  id="chan"
                  href="//www.easemytrip.com/directory/flights.html"
                >
                  Flight by City
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="//www.easemytrip.com/directory/packages.html"
                >
                  Holidays
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="//www.easemytrip.com/directory/airlines.html"
                >
                  Airlines
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="//www.easemytrip.com/airports/airports-in-india.html"
                >
                  Airports
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="//www.easemytrip.com/directory/domestic-flight-schedule.html"
                >
                  Flight Schedule
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/directory/train-routes.html"
                >
                  Train Routes
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/directory/bus-routes.html"
                >
                  Bus Routes
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/directory/hotels-in-india.html"
                >
                  Hotel Directory
                </Link>
              </li>
              <li>
                <Link id="chan" href="//www.easemytrip.com/travel-guides.html">
                  Travel Guides
                </Link>
              </li>
              <li>
                <Link id="chan" href="https://www.easemytrip.com/blog/">
                  Blog
                </Link>
              </li>
              <li>
                <Link id="chan" href="//www.easemytrip.com/travel-updates.html">
                  Travel Updates
                </Link>
              </li>
              <li>
                <Link id="chan" href="//www.easemytrip.com/sitemap.html">
                  Sitemap
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/offers/flights.html"
                >
                  Flight Offers
                </Link>
              </li>
            </ul>
          </div>
          <div className="ftr_col_1">
            <div className="ftr_ttl"> Popular Airlines </div>
            <ul>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/indigo.html"
                >
                  IndiGo Airlines
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/air-india.html"
                >
                  Air India Airlines
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/goair.html"
                >
                  GO FIRST Airlines
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/vistara.html"
                >
                  Vistara Airlines
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/spicejet.html"
                >
                  SpiceJet Airlines
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/air-asia.html"
                >
                  Air Asia Airlines
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/british-airways.html"
                >
                  British airways
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/qatar-airways.html"
                >
                  Qatar airways
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/singapore-airlines.html"
                >
                  Singapore Airlines
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/etihad-airways.html"
                >
                  Etihad airways
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/thai-airways.html"
                >
                  Thai airways
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/united-airlines.html"
                >
                  United Airlines
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/airline-tickets/american-airlines.html"
                >
                  American Airlines
                </Link>
              </li>
              <li>
                <Link
                  id="chan"
                  href="https://www.easemytrip.com/offers/malaysian-airlines.html"
                >
                  Malaysia Airlines
                </Link>
              </li>
            </ul>
          </div>
          <div className="ftr_col_2">
            <div className="ftr_col_inr">
              <div className="ftr_ttl">Payment & Security </div>
              <div className="cards">
                <Link id="chan" className="visa" title="Visa"></Link>
                <Link id="chan" className="master" title="Master Card"></Link>
                <Link
                  id="chan"
                  className="american"
                  title="American Express"
                ></Link>
                <Link id="chan" className="py_pal" title="PayPal"></Link>
                <div className="clr"></div>
                <Link id="chan" className="rupaylg" title="RuPay"></Link>
                <Link id="chan" className="pcilg" title="PCI Security"></Link>
              </div>
              <div className="ftr_ttl">Follow us on </div>
              <div className="social">
                <Link
                  id="chan"
                  href="https://www.facebook.com/EaseMyTrip/"
                  target="_new"
                  title="Facebook"
                  className="fb_b"
                >
                  <span className="fb_n"></span>
                </Link>
                <Link
                  id="chan"
                  href="https://twitter.com/easemytrip"
                  title="Twitter"
                  target="_new"
                  className="tw_b"
                >
                  <span className="tw_n"></span>
                </Link>
                <Link
                  id="chan"
                  href="https://www.youtube.com/c/EaseMyTripOfficial"
                  title="You Tube"
                  target="_new"
                  className="yt_b"
                >
                  <span className="yt_n"></span>
                </Link>
                <Link
                  id="chan"
                  href="https://www.linkedin.com/company/easemytrip-com"
                  title="LinkedIn"
                  target="_new"
                  className="li_b"
                >
                  <span className="li_n"></span>
                </Link>
                <Link
                  id="chan"
                  href="https://www.instagram.com/easemytrip/"
                  title="Instagram"
                  target="_new"
                  className="in_b"
                >
                  <span className="in_n"></span>
                </Link>
              </div>
            </div>
          </div>
          <div className="ftr_col_3">
            <div className="ap_d_cn">
              <span>Download</span> EaseMyTrip App{" "}
            </div>
            <Link
              id="chan"
              href="//play.google.com/store/apps/details?id=com.easemytrip.android"
              className="pl_store hvr-wobble-horizontal"
              title="Google Play Store"
            ></Link>
            <Link
              id="chan"
              href="https://itunes.apple.com/in/app/easemytrip-flight-booking/id1053030595?mt=8"
              className="app_store hvr-wobble-horizontal"
              title="App Store"
            ></Link>
          </div>
        </div>
        <div className="clr"></div>
        <div className="brdr_1"></div>
        <div className="footer_inr">
          <div className="ftr_col_4">Copyright &copy; 2021 EaseMyTrip</div>
          <div className="ftr_col_5">
            <ul>
              <li>
                <img src="https://www.easemytrip.com/images/common/footer-btm-sprite.png" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export { Footer };
